/** A file name's extension, without the dot; empty when it has none. */
export const fileExtension = (name: string) => {
  const dot = name.lastIndexOf('.');
  const extension = dot > 0 ? name.slice(dot + 1) : '';
  return /^[\p{L}\p{N}]{1,8}$/u.test(extension) ? extension : '';
};

/**
 * A long file name shortened in the middle (ClickUp 869fnf1b8): counted in
 * characters, never cutting å, ä, ö or an emoji in two, with "…" where text
 * was left out and the end with the extension kept, so the type stays
 * visible ("Underlag för badrums…Björkängen.pdf"). Show the whole name as
 * the element's title. Contract terms and the contract PDF always show the
 * whole name: there it is a legal reference.
 */
export const shortFileName = (name: string, maxLength = 48) => {
  const characters = Array.from(name);
  if (characters.length <= maxLength) return name;
  const extension = fileExtension(name);
  const tailLength = Math.max(Math.min(12, Math.floor(maxLength / 3)), extension.length + 1);
  const headLength = Math.max(maxLength - tailLength - 1, 1);
  return `${characters.slice(0, headLength).join('').trimEnd()}…${characters.slice(-tailLength).join('').trimStart()}`;
};
